export function getInnerContainerStyle(_ref) {
  var animationDuration = _ref.animationDuration;
  return {
    animation: "scroll ".concat(animationDuration, "s linear infinite")
  };
}